export class Series {
  code: string;
  special_code: string;
}
